import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  ImaxxActions,
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { mapTreatmentPlanBenefits } from "./maps";
import { InsurancePolicyBenefit } from "./insurance-policy-benefit";

export const featureKey = "insurancePolicyBenefits";

export type InsurancePolicyBenefitState = EntityState<InsurancePolicyBenefit>;

export const adapter = createEntityAdapter<InsurancePolicyBenefit>({
  selectId: (insurance) => insurance.id,
  sortComparer: false,
});

export const initialState: InsurancePolicyBenefitState = adapter.getInitialState(
  {}
);

export const reducer = createReducer(
  initialState,
  on(TreatmentPlanApiActions.loadBenefitSuccess, (state, { benefits }) => {
    return adapter.setAll(
      benefits
        .map((b) => mapTreatmentPlanBenefits(b))
        .reduce((pv, cv) => pv.concat(...cv), []),
      state
    );
  }),
  /** Add a policies' benefit details to the InsurancePolicyBenefits list. */
  on(
    TreatmentPlanApiActions.addBenefitSuccess,
    (state, { insurancePolicyBenefit }) =>
      adapter.addOne(insurancePolicyBenefit, state)
  ),
  on(TreatmentPageActions.treatmentPlanRemoved, (state, { id }) =>
    adapter.removeMany(
      Object.keys(state.entities).filter(
        (k) => state.entities[k].treatmentPlanId === id
      ),
      state
    )
  ),
  on(TreatmentPageActions.benefitOverridden, (state, benefitOverridden) => {
    const key = Object.keys(state.entities).find(
      (k) =>
        state.entities[k].treatmentPlanId ===
          benefitOverridden.treatmentPlanId &&
        state.entities[k].insurancePolicyPatientEligibilityId ===
          benefitOverridden.insurancePolicyId
    );
    return adapter.updateOne(
      {
        id: key,
        changes: { benefit: benefitOverridden.benefit },
      },
      state
    );
  }),
  on(TreatmentPlanApiActions.calculateSuccess, (state, { benefit }) =>
    adapter.upsertMany(mapTreatmentPlanBenefits(benefit), state)
  ),
  on(
    ImaxxActions.updateImaxxOptimizerSuccess,
    (state, { TreatmentPlanBenefit }) => {
      if (TreatmentPlanBenefit) {
        return adapter.upsertMany(
          mapTreatmentPlanBenefits(TreatmentPlanBenefit),
          state
        );
      } else {
        return state;
      }
    }
  ),
  on(TreatmentPlanApiActions.loadBenefitSuccess, (state, { benefits }) => {
    return adapter.setAll(
      benefits
        .map((b) => mapTreatmentPlanBenefits(b))
        .reduce((pv, cv) => pv.concat(...cv), []),
      state
    );
  })
);
